import CreateAdmin from "./CreateAdmin";
import { useState } from "react";
import { useEffect } from "react";
import PopupAlert from "../../components/PopupAlert";

const ViewAdminsComponent = ({ setShowNav, link }) => {
  const [createAdmin, setCreateAdmin] = useState(false);

  const [adminData, setAdminData] = useState([]);

  const [deleteData, setDeleteData] = useState(false);
  const [adminId, setAdminId] = useState(null);

  const fetchData = async () => {
    try {
      const response = await fetch(`${link}/all-admin`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "GET",
      });

      const responseData = await response.json();

      if (response.ok) {
        setAdminData(responseData.data);
      } else alert(responseData.message || "something went wrong");
    } catch (error) {
      alert("Server Errorrr");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const handleDelete = async () => {
    try {
      const response = await fetch(`${link}/delete-admin/${adminId}`, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "DELETE",
      });

      if (response.ok) {
        fetchData();
        setDeleteData(false);
      } else {
        const responseData = await response.data();
        alert(responseData.message || "something went wrong");
      }
    } catch (error) {
      alert("Server Error");
    }
  };

  return (
    <div>
      {createAdmin ? (
        <CreateAdmin open={setCreateAdmin} link={link} fetchData={fetchData} />
      ) : (
        ""
      )}

      {deleteData ? (
        <div className="dboard-log-out-alert-n">
          <PopupAlert
            heading="Are you sure to delete admin !?"
            icon="fa-solid fa-trash-can"
            open={setDeleteData}
            action={handleDelete}
          />
        </div>
      ) : (
        ""
      )}

      <div className="goc-dashbord-right-side-main-head">
        <div>
          <span
            className="goc-dash-bord-menu-sm-open-ion"
            onClick={() => setShowNav(true)}
          >
            <i class="fa-solid fa-bars"></i>
          </span>{" "}
          Admins
        </div>

        <div className="goc-dashbord-left-side-menu-log-out-button">
          <div onClick={() => setCreateAdmin(true)}>Create New Admin</div>
        </div>
      </div>

      <div className="all-admin-list">
        <div className="all-admin-list-main">
          {adminData.length > 0 ? (
            adminData.map((e, i) => (
              <div>
                <div>
                  <span>{1 + i}. </span> {e.email}
                </div>
                <i
                  onClick={() => {
                    setDeleteData(true);
                    setAdminId(e._id);
                  }}
                  class="fa-solid fa-trash-can"
                ></i>
              </div>
            ))
          ) : (
            <h3>no more admins.</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewAdminsComponent;
